// 📐 Functions
const clearErrorMessage = (input) => {
  const inputWrapper = input.closest("[data-validate-input-wrapper]");
  const errorMessage = inputWrapper
    ? inputWrapper.querySelectorAll("[data-validate-message]")
    : null;
  const errorIcon = inputWrapper.querySelector("[data-validate-icon-error]");
  const successIcon = inputWrapper.querySelector(
    "[data-validate-icon-success]",
  );

  if (errorIcon) {
    // Error icon class reset
    errorIcon.classList.remove("input-icon--show");
  }

  if (successIcon) {
    // Success class reset
    successIcon.classList.remove("input-icon--show");
  }

  if (inputWrapper && errorMessage.length !== 0) {
    // Error message class reset
    Array.from(errorMessage).forEach((message) => {
      message.classList.remove("input-message--show");
    });
  }
};

const showErrorMessage = (input, messageEl) => {
  const inputWrapper = input.closest("[data-validate-input-wrapper]");
  const errorMessage = inputWrapper
    ? inputWrapper.querySelector(messageEl)
    : null;
  const errorIcon =
    inputWrapper !== null
      ? inputWrapper.querySelector("[data-validate-icon-error]")
      : null;

  // Reset messages
  clearErrorMessage(input);

  if (errorMessage) {
    // Error message class
    errorMessage.classList.add("input-message--show");
  }

  if (errorIcon) {
    // Error icon class
    errorIcon.classList.add("input-icon--show");
  }
};

const showSuccessMessage = (input) => {
  const inputWrapper = input.closest("[data-validate-input-wrapper]");
  const successIcon = inputWrapper.querySelector(
    "[data-validate-icon-success]",
  );

  if (input.checkValidity()) {
    clearErrorMessage(input);
  }

  if (input.checkValidity() && successIcon) {
    successIcon.classList.add("input-icon--show");
  }
};

// 📤 Export
export { showErrorMessage, showSuccessMessage, clearErrorMessage };
